import { AggregateBusinessFilterProperty } from '@/coreDomainsModule/entities/filter';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 *  5つのキーを元にAggregateBusinessIdを取得する
 */
export class GetAggregateBusinessIdUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 5つのキーを元にAggregateBusinessIdを取得する
   * @param selectedInfo - 選択中の情報
   */
  public async Execute(selectedInfo: AggregateBusinessFilterProperty): Promise<INetworkResult<string, IError>> {
    try {
      const response = await this.repository.getAggregateBusinessId(selectedInfo);
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: response.status.data,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
